// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AnalyticsNavigationController from "./analytics_navigation_controller"
application.register("analytics-navigation", AnalyticsNavigationController)

import ChatScrollController from "./chat_scroll_controller"
application.register("chat-scroll", ChatScrollController)

import ChatTitleEditorController from "./chat_title_editor_controller"
application.register("chat-title-editor", ChatTitleEditorController)

import ClickableTableRowController from "./clickable_table_row_controller"
application.register("clickable-table-row", ClickableTableRowController)

import FocusController from "./focus_controller"
application.register("focus", FocusController)

import ProgramChatController from "./program_chat_controller"
application.register("program-chat", ProgramChatController)

import FormValidationController from "./form_validation_controller"
application.register("form-validation", FormValidationController)

import TextareaAutogrowController from "./textarea_autogrow_controller"
application.register("textarea-autogrow", TextareaAutogrowController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import WistiaVideoController from "./wistia_video_controller"
application.register("wistia-video", WistiaVideoController)
